import { css as n, styled as e } from "styled-components";
import { SmallHeavy as y, CaptionHeavy as b, H3Heavy as $, Caption as u, Small as h } from "../../../../styles/typography/index.js";
import { Colors as a } from "../../../../styles/colors/index.js";
import { MediaQuery as o } from "../../../../styles/variables.js";
import { Icon as S } from "../../../../components/Icon/index.js";
import { DealImageContainer as v, ImageComponent as C, DealImageSkeletonContainer as k } from "../../DealImage/style.js";
import { DealImage as w } from "../../DealImage/index.js";
import { TextSkeleton as l } from "../../../../components/TextSkeleton/index.js";
import { skeletonFadeAnimation as p } from "../../../../styles/animation.js";
import { SmartLink as m } from "../../../../components/SmartLink/index.js";
import { DealCardCouponStamp as E } from "../components/DealCardCouponStamp/index.js";
import { DealImageBadgeContainer as _ } from "../../DealImageBadge/style.js";
import { Theme as i } from "../../../../styles/themes/index.js";
import { DealStoreLabel as D } from "../../DealStoreLabel/index.js";
const c = n`
  text-decoration: none;
  border-radius: 16px;
  border: 1px solid rgb(${i.colors.Golf});
  background-color: rgb(${i.colors.Juliet});
`, g = n`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 12px;
  grid-template-areas:
    'image content'
    'action action';
  padding: 16px 16px 12px 12px;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      padding: 12px 16px 24px;

      grid-template-columns: auto 1fr;
      column-gap: 16px;
      grid-template-rows: 1fr auto;
      grid-template-areas:
        'image content'
        'image action';
    }
  }
`, K = e.div`
  ${g}
  position:relative;
  pointer-events: none;
  z-index: 1;
`, Q = e.div`
  border-bottom: 1px solid rgb(${i.colors.Golf});
  padding: 8px 16px;
  overflow: hidden;
`, V = e.div`
  background: transparent;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
`, q = e.div`
  background: transparent;
  border-radius: 0 0 16px 16px;
  overflow: hidden;

  &[data-is-visible='false'] {
    display: none;
  }
`, O = e.div`
  ${y}
  display: flex;
  background-color: rgb(${i.colors.Brand});
  color: rgb(${a.White});
  align-items: center;
  padding: 8px 16px;

  svg {
    fill: rgb(${a.Black});
    margin-right: 8px;
  }
`, X = e.div`
  ${c}
  position:relative;
  cursor: ${({ disableclick: t }) => t ? "default" : "pointer"};
`, Y = e.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  ${({ disableclick: t }) => t ? "pointer-events: none;" : ""};
`, Z = e.div`
  grid-area: image;
  display: flex;
  pointer-events: all;
  cursor: ${({ disableclick: t }) => t ? "default" : "pointer"};
  ${({ disableclick: t }) => t ? "pointer-events: none;" : ""};
`, x = n`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 102px;
  max-width: 102px;
  max-height: 102px;
  min-height: 102px;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      min-width: 146px;
      max-width: 146px;
      max-height: 146px;
      min-height: 146px;
    }
  }
`, ee = e(w)`
  ${x}

  ${v} {
    border: none;

    img {
      object-fit: contain;
    }
  }

  ${C} {
    transition: transform 0.5s cubic-bezier(0.6, 0, 0.4, 1);

    &:hover {
      transform: scale(1.3);
    }
  }

  ${_} {
    height: 24px;
  }
`, N = e(m)`
  ${b}
  text-decoration: none;
  grid-area: title;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  color: rgb(${i.colors.Alpha});
  transition: color 0.5s ease;

  pointer-events: ${({ disablePointerEvents: t }) => t ? "none" : "all"};
  cursor: ${({ disablePointerEvents: t }) => t ? "default" : "pointer"};

  &:hover {
    color: rgb(${i.colors.Brand});
  }

  margin-top: 4px;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      ${$}
      margin-top: 0;
    }
  }
`, te = e.div`
  ${u}
  color: rgb(${a.Gray});
  margin-right: 3px;
  display: flex;
`, oe = e(m)`
  ${h}
  grid-area: store-mobile-name;
  text-decoration: none;
  color: rgb(${a.Gray});

  pointer-events: ${({ disablePointerEvents: t }) => t ? "none" : "all"};

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      display: none;
    }
  }
`, P = e(E)`
  margin-right: 8px;
`, R = n`
  a,
  ${P}, ${N} {
    color: rgb(${a.Gray});
  }
`, ie = e.div`
  grid-area: content;
  &[aria-disabled='true'] {
    ${R}
  }
`, ae = e.div`
  display: grid;
  grid-template-areas:
    'store-mobile-name timestamp'
    'title title';
  align-items: center;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      grid-template-areas: 'title timestamp';
      align-items: flex-start;
    }
  }
`;
e(S)`
  font-size: 24px;
  color: ${i.colors.Kilo};
  display: none;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      display: flex;
    }
  }
`;
const ne = e.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  flex-direction: column-reverse;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      margin-top: 12px;
      flex-direction: unset;
    }
  }
`, re = e.div`
  pointer-events: all;
  grid-area: action;
  margin-top: 16px;

  > div {
    display: flex;
    align-items: center;
  }
`, le = e.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      width: auto;
    }
  }
`, de = e(D)`
  display: none;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      display: flex;
    }
  }
`, se = e(l)`
  margin-right: 12px;
  width: 80px;
`, d = e(l)`
  width: 12%;
  min-width: 60px;
`, pe = e.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`, me = e.div`
  display: flex;
  justify-content: space-between;
  height: auto;
  max-height: 60px;
  width: 100%;
  ${d} {
    display: none;
  }

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_LG_UP} {
      ${d} {
        display: flex;
      }
    }
  }
`, ce = e.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_LG_UP} {
      display: none;
    }
  }
`, s = e(l)`
  width: 12%;
  min-width: 60px;
`, f = n`
  height: 32px;
  border-radius: 18px;
  margin-bottom: 4px;
  ${p({ animate: !0 })}
`, r = e.div`
  width: 40px;
  ${f}
`, ge = e.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  justify-content: space-between;

  ${s} {
    display: none;
  }
  ${r} {
    display: flex;
  }

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      ${r} {
        display: none;
      }
      justify-content: inherit;
    }

    @media ${o.SCREEN_LG_UP} {
      ${s} {
        display: flex;
      }
    }
  }
`, xe = e.div`
  ${c}
  ${g}

  ${({ animate: t }) => p({ animate: t, disableBackground: !0 })}
`, fe = e(k)`
  ${x}
  grid-area: image;
`, ye = e.div`
  width: 30%;
  ${f}
`, be = e.div`
  display: flex;
  justify-content: space-between;
`, $e = e.div`
  display: flex;
  align-items: center;

  ${r} {
    display: none;
  }

  &[data-keep-mobile-layout='false'] {
    @media ${o.SCREEN_MD_UP} {
      ${r} {
        display: flex;
      }
    }
  }
`;
export {
  ne as Body,
  be as BottomContainer,
  re as BottomContent,
  Y as CardClick,
  q as CashbackContentContainer,
  O as CashbackFooter,
  X as Container,
  K as ContainerGrid,
  xe as ContainerSkeleton,
  ie as Content,
  de as CustomDealStoreLabel,
  ye as DealCardButtonSkeleton,
  r as DealShareButtonSkeleton,
  V as FooterContentContainer,
  ge as FooterSkeleton,
  Q as HeaderContentContainer,
  ce as HeaderSkeleton,
  ee as Image,
  fe as ImageSkeleton,
  Z as ImageWrapper,
  ae as Info,
  P as Stamp,
  le as StampShareContainer,
  se as StampSkeleton,
  oe as StoreMobileLink,
  s as StoreSkeleton,
  te as StoreTextFixedCard,
  d as TimeStampSkeleton,
  N as Title,
  me as TitleSkeleton,
  pe as TitleSkeletonContainer,
  $e as VoteCommentSkeletonContainer,
  g as containerGridStyle
};
